import Index from '@/components/resource/Index.vue'
import Equip from '@/components/resource/equip/Index.vue'
import Machine from '@/components/resource/machine/Index.vue'
import Inputs from '@/components/resource/inputs/Index.vue'
import InputsAll from '@/components/resource/inputs/InputsAll.vue'
import InputsEdit from '@/components/resource/inputs/Edit.vue'
import EquipEditor from '@/components/resource/equip/EquipEditor.vue'
export default {
  path: 'resource',
  component: Index,
  children: [
    /**
     * 设备管理（智能设备）
     */
    {
      path: 'equip',
      component: Equip
    },
    /**
     * 设备管理 添加或编辑
     */
    {
      path: 'equip-editor',
      component: EquipEditor
    },
    /**
     * 农机管理
     */
    {
      path: 'machine',
      component: Machine
    },
    /**
     * 投入品（种子化肥农药）
     */
    {
      path: 'inputs',
      component: Inputs
    },
        /**
     * 投入品（种子化肥农药）(所有)
     */
    {
      path: 'inputs-all',
      component: InputsAll
    },
    /**
     * 投入品编辑，包括新增和修改
     */
    {
      path: 'inputs/:id',
      component: InputsEdit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/resource.js